import{z as n}from"zod";function m(r){return n.enum([r[0],...r.slice(1)])}export{m as a};
